(() => {
  if (customElements.get('bentivana-review-carousel')) return;

  class BentivanaReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bvr-carousel__track');
      if (!this.track || this.controller) return;
      this.cards = [...this.track.querySelectorAll('.bvr-carousel__item')];
      if (this.cards.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Math.max(5000, Number(this.dataset.interval) || 6000);
      this.autoplay = this.dataset.autoplay !== 'false';
      this.hovered = this.focused = this.dragging = false;
      this.clones = [];
      if (!window.Shopify?.designMode) {
        const copySet = () => this.cards.map(card => {
          const clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          [clone, ...clone.querySelectorAll('*')].forEach(node => {
            node.removeAttribute('id');
            node.removeAttribute('data-shopify-editor-block');
          });
          this.clones.push(clone);
          return clone;
        });
        this.track.prepend(...copySet());
        this.track.append(...copySet());
        this.classList.add('bvr-carousel--loop');
      }
      this.measure = () => {
        this.start = this.clones.length ? this.cards[0].offsetLeft - this.track.firstElementChild.offsetLeft : 0;
        this.cycle = this.start;
        this.step = this.cards[1].offsetLeft - this.cards[0].offsetLeft;
        this.track.scrollLeft = this.start;
        this.position = this.track.scrollLeft;
      };
      this.measure();
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.track);
      this.track.addEventListener('scroll', () => {
        this.normalize();
        this.position = this.track.scrollLeft;
      }, { ...options, passive: true });
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') this.hovered = true; }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; }, options);
      this.addEventListener('pointerdown', () => { this.dragging = true; }, options);
      window.addEventListener('pointerup', () => { this.dragging = false; }, options);
      window.addEventListener('pointercancel', () => { this.dragging = false; }, options);
      this.addEventListener('focusin', () => { this.focused = true; }, options);
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) this.focused = false; }, options);
      this.addEventListener('shopify:block:select', e => {
        const card = e.target.closest('.bvr-carousel__item');
        if (this.cards.includes(card)) this.track.scrollLeft = card.offsetLeft - this.track.firstElementChild.offsetLeft;
      }, options);
      const tick = time => {
        const elapsed = Math.min(50, time - (this.lastTime || time));
        this.lastTime = time;
        if (this.autoplay && this.cycle && !this.motion.matches && !document.hidden && !this.hovered && !this.focused && !this.dragging) {
          this.position += elapsed * this.step / this.interval;
          this.track.scrollLeft = this.position;
          this.normalize();
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    normalize() {
      if (!this.cycle) return;
      const left = this.track.scrollLeft;
      if (left >= this.start + this.cycle) {
        this.track.scrollLeft = left - this.cycle;
        this.position = this.track.scrollLeft;
      } else if (left < this.start) {
        this.track.scrollLeft = left + this.cycle;
        this.position = this.track.scrollLeft;
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.clones?.forEach(clone => clone.remove());
      this.classList.remove('bvr-carousel--loop');
      this.lastTime = null;
    }
  }
  customElements.define('bentivana-review-carousel', BentivanaReviewCarousel);
})();
